module.exports = __webpack_public_path__ + "img/project1_small@2x.6ec64a07.webp";